import {
  InputTextMaster,
  Loading,
  MasterButton,
  Modal,
  TableAction,
} from "App/Component/ui";
import { Grid, TableCell, TableRow } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { DISABLED_BUTTON_SUBMIT, instance3 } from "App/constants";
import {
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
} from "App/utils/helpers";
import InputFileCustom from "App/Component/ui/input/InputFileCustom/InputFileCustom";
import { Refresh, Save } from "@material-ui/icons";
import { FreezeTableClient } from "components/organism";
import { useDatatables } from "App/hooks";
import { headCellsDetail, headCellsUpload, StatusImport } from "./helpers";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA } from "../helpers";

const ModalImport = ({
  setShowModal,
  setNewData,
  datas,
  title = "Import Data Tagihan",
  subTitle = "Daftar Import Tagihan Rekap",
  withDetail = false,
  url = "",
  urlGetImport = "",
  urlDetail = "",
  status_proses,
}) => {
  const getImportById = async (id) => {
    try {
      const api = await instance3.post(urlGetImport, {
        id: "",
        role: "1",
        id_rekap: id,
      });
      const res = api.data;

      if (api.status === 200) {
        return {
          state: true,
          data: res.data,
        };
      } else {
        return {
          state: false,
          message: res.data.message,
        };
      }
    } catch (error) {
      return {
        state: false,
        message: error?.response?.data?.message,
      };
    }
  };

  useEffect(() => {
    setNewImportTagihan();
  }, []); // eslint-disable-line

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const setNewImportTagihan = async () => {
    if (!isNull(formData.rekap_tagihan_id)) {
      setLoading(true);
      const res = await getImportById(formData.rekap_tagihan_id);
      if (res.state) {
        setLoading(false);
        setRows(res.data);
      } else {
        setLoading(false);
        setRows([]);
        defaultToastError(res.message);
      }
    }
  };

  const SHOW_LOAD_BUTTON = {
    label: "PROSES",
    color: "green",
    state: false,
    disabled: false,
  };
  const [disabled, setDisabled] = useState(SHOW_LOAD_BUTTON);
  const [showDetail, setShowDetail] = useState(false);
  const [formData, setFormData] = useState({
    rekap_tagihan_id: datas.rekap_tagihan_id,
    no_surat: datas.no_surat,
    asuransi: datas.asuransi_nama,
    id_import: "",
  });
  const [file, setFile] = useState(null);

  const handleClickUpload = async () => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(file)) {
        setDisabled(SHOW_LOAD_BUTTON);
        defaultToastError("Harap pilih file terlebih dahulu");
      } else {
        const newFormData = new FormData();
        newFormData.append("excelFile", file);
        newFormData.append("rekap_tagihan_id", formData.rekap_tagihan_id);

        instance3.post(url, newFormData);

        // if (res.data.status === 200) {
        defaultToastSuccess(
          "Data dalam proses, silahkan periksa secara berkala.."
        );
        setDisabled(SHOW_LOAD_BUTTON);
        setNewData();
        setFile(null);
        setNewImportTagihan();
        // } else {
        //   defaultToastError(
        //     "Terjadi kesalahan ! Silahkan periksa kembali file excel yang diupload"
        //   );
        //   setDisabled(SHOW_LOAD_BUTTON);
        //   setNewData();
        // }
      }
    } catch (error) {
      setDisabled(SHOW_LOAD_BUTTON);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleSelect = async (row) => {
    await setFormData({ ...formData, id_import: row?.id });
    setShowDetail(true);
  };

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });
  return (
    <>
      <Modal title={title} show={setShowModal} width={"70%"}>
        {showDetail && (
          <ModalTableDetail
            setShowModal={() => setShowDetail(false)}
            datas={formData}
            urlDetail={urlDetail}
          />
        )}
        <Grid container spacing={2}>
          <Grid item sm={4}>
            <InputTextMaster
              name="rekap_tagihan_id_upload"
              label="ID"
              id="rekap_tagihan_id"
              placeholder="ID"
              disabled={true}
              readOnly={true}
              value={formData.rekap_tagihan_id}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="asuransi"
              label="ASURANSI"
              id="idgl"
              placeholder="Asuransi"
              disabled={true}
              readOnly={true}
              value={formData.asuransi}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="no_surat_upload"
              label="NO. SURAT"
              id="idgl"
              placeholder="No. Surat"
              disabled={true}
              readOnly={true}
              value={formData.no_surat}
            />
          </Grid>
          <Grid item sm={8}>
            <label
              htmlFor="fileTagihanImport"
              style={{
                fontWeight: 400,
                color: "#BDBDBD",
                fontSize: "11px",
              }}
            >
              Pilih File
            </label>
            <InputFileCustom
              convertToBase64={false}
              label={"Upload File"}
              name={"fileTagihanImport"}
              id={"fileTagihanImport"}
              initialNameFile={file}
              setFile={setFile}
              accept={".xls, .xlsx"}
              disabled={
                status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA
                  ? false
                  : true
              }
            />
            <label
              style={{
                position: "absolute",
                left: "23px",
                fontWeight: 400,
                color: "#BDBDBD",
                fontSize: "11px",
              }}
            >
              *File yang diizinkan .xls, .xlsx; Sempel bisa didownload pada
              export excel pada menu daftar tagihan
            </label>
          </Grid>
          <Grid item sm={2}>
            <MasterButton
              type="submit"
              outline={true}
              name={disabled.label}
              disabled={
                status_proses !== STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA
                  ? true
                  : disabled.disabled
              }
              color={
                status_proses !== STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA
                  ? "secondary"
                  : disabled.color
              }
              className={"ml-1"}
              onClick={() =>
                status_proses !== STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA
                  ? null
                  : disabled.disabled
                  ? null
                  : handleClickUpload()
              }
              size="sm"
              withIcon={true}
              style={{
                padding: "0.5rem 1.9rem",
                fontSize: "15px",
                marginTop: "24px",
              }}
              icon={
                <Save
                  width="15px"
                  height="15px"
                  style={{
                    marginLeft: "-0.5rem",
                  }}
                />
              }
            />
          </Grid>
          <Grid item sm={2}>
            <MasterButton
              type={"button"}
              color="green"
              outline={true}
              onClick={async () => {
                setNewImportTagihan();
              }}
              name="Refresh Data"
              size="sm"
              style={{
                padding: "0.5rem 1rem",
                fontSize: "15px",
                marginTop: "24px",
              }}
              withIcon={true}
              icon={<Refresh width="15px" height="15px" />}
            />
          </Grid>
          <Grid item sm={12} className={"mb-2"}>
            <Loading show={loading} />
            <FreezeTableClient
              title={subTitle}
              setQ={setQ}
              withExportButton={false}
              order={order}
              orderBy={orderBy}
              handleRequestSort={handleRequestSort}
              length={length}
              rows={rows}
              headCells={headCellsUpload}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
            >
              {stableSort(data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={index}>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="left">
                        {withDetail && (
                          <TableAction
                            isUpdate={false}
                            isDelete={false}
                            isSelect={true}
                            clickSelect={(e) => handleSelect(row)}
                          />
                        )}
                      </TableCell>
                      <TableCell align="left">{row?.id}</TableCell>
                      <TableCell align="left">{row?.id_rekap}</TableCell>
                      <TableCell align="center">
                        <StatusImport str={row.status} />
                      </TableCell>
                      <TableCell align="left">
                        {isNull(row?.total_data_gagal)
                          ? "-"
                          : formatNumber(row?.total_data_gagal)}
                      </TableCell>
                      <TableCell align="left">
                        {isNull(row?.total_data_masuk)
                          ? "-"
                          : formatNumber(row?.total_data_masuk)}
                      </TableCell>
                      <TableCell align="left">
                        {isNull(row?.total_data)
                          ? "-"
                          : formatNumber(row?.total_data)}
                      </TableCell>
                      <TableCell align="left">
                        {isNull(row?.remark) ? "-" : row?.remark}
                      </TableCell>
                      <TableCell align="left">
                        {defaultDateDisplay(row?.createdAt, true)}
                      </TableCell>
                      <TableCell align="left">{row?.createdBy}</TableCell>
                    </TableRow>
                  );
                })}
            </FreezeTableClient>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

export default ModalImport;

const ModalTableDetail = ({ setShowModal, datas, urlDetail }) => {
  const [rowsDetail, setRowsDetail] = useState([]);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const getDetailImportById = async (id) => {
    try {
      const api = await instance3.get(`${urlDetail}/${id}`);
      const res = api.data;

      if (api.status === 200) {
        return {
          state: true,
          data: res.data.detail,
        };
      } else {
        return {
          state: false,
          message: res.data.message,
        };
      }
    } catch (error) {
      return {
        state: false,
        message: error?.response?.data?.message,
      };
    }
  };

  useEffect(() => {
    setNewImportTagihan();
  }, []); // eslint-disable-line

  const setNewImportTagihan = async () => {
    if (!isNull(datas.id_import)) {
      setLoadingDetail(true);
      const res = await getDetailImportById(datas.id_import);
      if (res.state) {
        setLoadingDetail(false);
        setRowsDetail(res.data);
      } else {
        setLoadingDetail(false);
        setRowsDetail([]);
        defaultToastError(res.message);
      }
    } else {
      setLoadingDetail(false);
      setRowsDetail([]);
    }
  };

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rowsDetail,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  return (
    <Modal title={"Detail"} show={setShowModal} width={"70%"}>
      <Grid container spacing={2}>
        <Grid item sm={12}>
          <Loading show={loadingDetail} />
          <FreezeTableClient
            title={"Detail Gagal Import"}
            setQ={setQ}
            withExportButton={false}
            order={order}
            orderBy={orderBy}
            handleRequestSort={handleRequestSort}
            length={length}
            rows={rowsDetail}
            headCells={headCellsDetail}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          >
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow hover tabIndex={-1} key={index}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="left">{row?.id}</TableCell>
                    <TableCell align="left">{row?.id_log}</TableCell>
                    <TableCell align="left">{row?.id_tagihan}</TableCell>
                    <TableCell align="left">{row?.id_rekap}</TableCell>
                    <TableCell align="left">{row?.remark}</TableCell>
                    <TableCell align="left">
                      {defaultDateDisplay(row?.createdAt, true)}
                    </TableCell>
                    <TableCell align="left">{row?.createdBy}</TableCell>
                  </TableRow>
                );
              })}
          </FreezeTableClient>
        </Grid>
      </Grid>
    </Modal>
  );
};
